export default __webpack_public_path__ + "static/footerLogo-8d5cac207a5a29af767f321080472838.svg";